export default {
      id: "client-usage",
      viewBox: "0 0 129.07 191",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#client",
      toString: function () {
        return this.url;
      }
    }